import React from 'react';
import { Query } from '@apollo/client/react/components';
import { FormattedMessage } from 'react-intl';
import { mapAfter } from 'apollo-relay/update-query';

import Modal from 'four-nets/ui-v2/modal/modal';
import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import FetchMore from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';

import LikersList from 'four-nets/photoblog/posts/common/likers-list/likers-list';
import query, { UserFriendsLoaderQuery, UserFriendsLoaderQueryVariables } from './user-friends-loader.graphql';

export interface Props {
    id: string;
    open: boolean;
    onClose: () => any;
}

interface State {
    loading?: boolean;
}

class UserFriendsDialog extends React.PureComponent<Props, State> {
    state = { loading: false };

    render() {
        const { id, open, onClose } = this.props;
        return (
            <Modal title={<FormattedMessage id='FRIENDS' />} open={open} onClose={onClose}>
                <Query<UserFriendsLoaderQuery, UserFriendsLoaderQueryVariables>
                    query={query}
                    variables={{ id }}
                    fetchPolicy='cache-first'
                >
                    {({ data, loading, fetchMore }) => {
                        return (
                            <LoadingWrapperView loading={loading}>
                                {data && data.user ? (
                                    <LikersList {...({ ...data.user, likers: data.user.friends } as any)} />
                                ) : null}
                                {data && data.user && data.user.friends && data.user.friends.pageInfo.hasNextPage ? (
                                    <FetchMore
                                        disabled={this.state.loading}
                                        loading={this.state.loading}
                                        onClick={() => {
                                            this.setState({ loading: true });
                                            const endCursor =
                                                data &&
                                                data.user &&
                                                data.user.friends &&
                                                data.user.friends.pageInfo.endCursor;

                                            fetchMore({
                                                variables: { endCursor },
                                                updateQuery: (
                                                    previousResult = {} as UserFriendsLoaderQuery,
                                                    { fetchMoreResult = {} as UserFriendsLoaderQuery }
                                                ) => {
                                                    return {
                                                        ...previousResult,
                                                        ...fetchMoreResult,
                                                        user: {
                                                            ...(previousResult && previousResult.user),
                                                            ...(fetchMoreResult && previousResult.user),
                                                            friends: mapAfter(
                                                                previousResult.user && previousResult.user.friends,
                                                                fetchMoreResult.user && fetchMoreResult.user.friends
                                                            ),
                                                        },
                                                    } as UserFriendsLoaderQuery;
                                                },
                                            }).then(() => {
                                                this.setState({ loading: false });
                                            });
                                        }}
                                    />
                                ) : null}
                            </LoadingWrapperView>
                        );
                    }}
                </Query>
            </Modal>
        );
    }
}

export default UserFriendsDialog;
